import { Droppable } from "@hello-pangea/dnd";
import { useSelector, useDispatch } from "react-redux";
import { removePuzzlePiece } from "../../store/reducers/phraseBuilderPlantel/phraseBuilderPlantel.slice";
import { Icon } from "@iconify/react/dist/iconify.js";

const PhrasePuzzlePlantel = () => {
  const dispatch = useDispatch();
  const { puzzle, leftWord, rightWord, leftRandom, rightRandom } = useSelector((s) => s.phraseBuilderPlantel);

  return (
    <div className="row g-4">
      {["left", "right"].map((side) => {
        const isLeft = side === "left";
        const word = isLeft ? leftWord : rightWord;
        const isRandom = isLeft ? leftRandom : rightRandom;
        
        return (
          <div key={side} className="col-12 col-md-6">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2 fw-semibold">
                    <Icon
                      icon={
                        side === "left"
                          ? "mdi:puzzle-outline"
                          : "mdi:puzzle-check-outline"
                      }
                      width={20}
                    />
                    {side === "left" ? "Zona izquierda" : "Zona derecha"}
                  </div>
                  {isRandom && (
                    <span className="badge bg-info-subtle text-info">
                      <Icon icon="mdi:shuffle-variant" width={12} className="me-1" />
                      Random
                    </span>
                  )}
                  {!isRandom && word && (
                    <span className="badge bg-primary-subtle text-primary">
                      {word.label}
                    </span>
                  )}
                </div>

              <Droppable droppableId={side}>
                {(prov) => (
                  <div
                    ref={prov.innerRef}
                    {...prov.droppableProps}
                    className="border rounded-3 p-4 bg-light-subtle d-flex align-items-center justify-content-center"
                    style={{ minHeight: 140 }}
                  >
                    {puzzle[side] ? (
                      <div className="alert alert-primary w-100 mb-0 d-flex justify-content-between align-items-center gap-2">
                        <span className="fw-medium">{puzzle[side].text}</span>

                        <button
                          className="btn btn-sm btn-danger d-flex align-items-center gap-1"
                          onClick={() => dispatch(removePuzzlePiece(side))}
                        >
                          <Icon icon="mdi:close" width={16} />
                          Quitar
                        </button>
                      </div>
                    ) : (
                      <div className="text-muted d-flex flex-column align-items-center gap-2">
                        <Icon icon="mdi:gesture-tap-hold" width={22} />
                        Suelta una palabra aquí
                      </div>
                    )}

                    {prov.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          </div>
        </div>
      );
      })}
    </div>
  );
};

export default PhrasePuzzlePlantel;
